<template>
  <Box>
    <template #handle>
      <!-- <Btn>批量处理数据状态</Btn> -->
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="采集时间" prop="cjtime">
                    <el-date-picker v-model="queryParams.cjtime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上传时间" prop="sctime">
                    <el-date-picker v-model="queryParams.sctime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上报时间" prop="sbtime">
                    <el-date-picker v-model="queryParams.sbtime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="加工年度" prop="nd">
                    <el-date-picker v-model="queryParams.nd" type="year" placeholder="选择年" format="yyyy"
                      value-format="yyyy" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区域" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="加工类型" prop="jglx">
                    <el-select v-model="queryParams.jglx" size="small" clearable>
                      <el-option v-for="item in jglx" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="112px" label="企业/企业代码" prop="companycode">
                    <el-select v-model="queryParams.companycode" size="small" filterable clearable>
                      <el-option v-for="item in componany" :key="item.id" :label="item.companycode + ' | ' + item.companyname" :value="item.companycode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="生产线" prop="sccode">
                    <el-select v-model="queryParams.sccode" size="small" clearable>
                      <el-option v-for="item in scxs" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="数据状态" prop="datastate">
                    <el-select v-model="queryParams.datastate" size="small" clearable>
                      <el-option v-for="item in datastate" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item label="上报状态" prop="upstate">
                    <el-select v-model="queryParams.upstate" size="small" clearable>
                      <el-option v-for="item in shangbzt" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="异性纤维" prop="yxxw">
                    <el-select v-model="queryParams.yxxw" size="small" clearable>
                      <el-option v-for="item in yxxw" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="querymsg">
          <el-row>
            <el-col :span="4">
              <span>企业生产线总数量：</span><span>{{ queryMsg.companyScxxCount }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总包数：</span><span>{{ queryMsg.bCount }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总皮重：</span><span>{{ queryMsg.pCount ? `${queryMsg.pCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总毛重：</span><span>{{ queryMsg.mCount ? `${queryMsg.mCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总净量：</span><span>{{ queryMsg.jCount ? `${queryMsg.jCount}Kg` : '' }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span>生产线平均产量：</span><span>{{ queryMsg.scxAverage }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>棉包平均皮重：</span><span>{{ queryMsg.ppCount ? `${queryMsg.ppCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>棉包平均毛重：</span><span>{{ queryMsg.mpCount ? `${queryMsg.mpCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>棉包平均净重：</span><span>{{ queryMsg.jpCount ? `${queryMsg.jpCount}Kg` : '' }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="queryTime">
              <div>时间</div>
              <div>
                <el-select v-model="queryTime" size="small" clearable
                  :disabled="!queryParams.companycode || !queryParams.sccode">
                  <el-option label="小于1分钟" value="1" />
                  <el-option label="小于2分钟" value="2" />
                </el-select>
              </div>
              <div v-if="queryParams.companycode && queryParams.sccode && queryTime">总包数：{{ queryCount }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="true" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <span v-if="data.head.handle == 'jglx'">{{
                (jglx.find((a) => a.value == data.data.jglx) || {}).label
                }}</span>
                <span v-if="data.head.handle == 'datastate'" :class="[data.data.datastate == '异常' ? 'red' : '']">{{
                data.data.datastate
                }}</span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" @click="handleItem(data.data, '数据详情')"
                    v-if="hasPermi('system:cjyw:dataDetails')">数据详情</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle">
        <template #content>
          <el-form :model="addForm" label-width="130px" :class="['demo-ruleForm', 'formBox', 'disabled']" disabled>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="加工年度：" prop="nd">
                  <el-input size="small" v-model="addForm.nd"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="包号：" prop="bh">
                  <el-input size="small" v-model="addForm.bh"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="毛重：" prop="mz">
                  <el-input size="small" v-model="addForm.mz">
                    <template slot="append">Kg</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="皮重：" prop="pz">
                  <el-input size="small" v-model="addForm.pz">
                    <template slot="append">Kg</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="净重：" prop="jz">
                  <el-input size="small" v-model="addForm.jz">
                    <template slot="append">Kg</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回潮：" prop="hc">
                  <el-input size="small" v-model="addForm.hc">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="籽棉等级：" prop="zmdj">
                  <el-input size="small" v-model="addForm.zmdj"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="垛号：" prop="dh">
                  <el-input size="small" v-model="addForm.dh"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="加工类型：" prop="jglx">
                  <el-select v-model="addForm.jglx" size="small" clearable>
                    <el-option v-for="item in jglx" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="日期：" prop="dates">
                  <el-input size="small" v-model="addForm.dates"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="生产线：" prop="scx">
                  <el-input size="small" v-model="addForm.scx"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="班次：" prop="bc">
                  <el-input size="small" v-model="addForm.bc"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="条码：" prop="tm">
                  <el-input size="small" v-model="addForm.tm"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="样批号：" prop="yph">
                  <el-input size="small" v-model="addForm.yph"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="棉花品种：" prop="mmpz">
                  <el-input size="small" v-model="addForm.mmpz"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="异性纤维：" prop="yxxw">
                  <el-select v-model="addForm.yxxw" size="small" clearable>
                    <el-option v-for="item in yxxw" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="追溯卡号1：" prop="mmOne">
                  <el-input size="small" v-model="addForm.mmOne"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="追溯卡号2：" prop="mmTwo">
                  <el-input size="small" v-model="addForm.mmTwo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="追溯卡号3：" prop="mmThree">
                  <el-input size="small" v-model="addForm.mmThree"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="追溯卡号4：" prop="mmFour">
                  <el-input size="small" v-model="addForm.mmFour"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="批号：" prop="ph">
                  <el-input size="small" v-model="addForm.ph"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备编号：" prop="sbcm">
                  <el-input size="small" v-model="addForm.sbcm"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="卷标号：" prop="jbh">
                  <el-input size="small" v-model="addForm.jbh"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="刷唛类型：" prop="smlx">
                  <el-select size="small" v-model="addForm.smlx">
                    <el-option v-for="item in BrandModels" :key="`${item.value}`" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="打印次数：" prop="dycount">
                  <el-input size="small" v-model="addForm.dycount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="轧花机监控：" prop="zhjjk">
                  <el-input size="small" v-model="addForm.zhjjk"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="数据状态：" prop="datastate">
                  <el-input size="small" v-model="addForm.datastate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否离线数据：" prop="lxsj">
                  <el-input size="small" v-model="addForm.lxsj"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="采集时间：" prop="cjtime">
                  <el-input size="small" v-model="addForm.cjtime"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上传时间：" prop="uptime">
                  <el-input size="small" v-model="addForm.uptime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="入库时间：" prop="intime">
                  <el-input size="small" v-model="addForm.intime"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上报状态：" prop="upstate">
                  <el-input size="small" v-model="addForm.upstate"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="上报时间：" prop="sbtime">
                  <el-input size="small" v-model="addForm.sbtime"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="修改时间：" prop="updateTime">
                  <el-input size="small" v-model="addForm.updateTime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="修改人：" prop="createUser">
                  <el-input size="small" v-model="addForm.createUser"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import {
  sbstate,
  jglx,
  datastate,
  shangbzt,
  options,
  yxxw,
  scxs,
  BrandModels
} from "@/utils/status";
import drawerMixins from "@/components/drawer/drawer";
import queryCompany from "@/api/queryCompanyByUser";
import moment from "moment";
import {
  cjywStatistics,
  dataDetails,
  minutePacket,
} from "@/api/BusinessDataManagement";
import permMixin from "@/mixins/perm";
import Region from "@/components/region";
export default {
  mixins: [drawerMixins, permMixin],
  components: { Region },
  data() {
    return {
      sbstate,
      jglx,
      datastate,
      shangbzt,
      options,
      yxxw,
      BrandModels,
      scxs,
      loading: false,
      queryTime: null,
      queryCount: 0,
      queryParams: {
        cjtime: [],
        sctime: [],
        sbtime: [],
        nd: "",
        qy: "",
        jglx: "",
        companyname: "",
        companycode: "",
        datastate: "",
        upstate: "",
        yxxw: null,
        sccode: "",
      },
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "nd",
          label: "加工年度",
          textAlign: "center",
        },
        {
          prop: "province",
          label: "省",
        },
        {
          prop: "city",
          label: "市",
          minWidth: 100,
        },
        {
          prop: "area",
          label: "区",
        },
        {
          prop: "companyname",
          label: "企业名称",
          minWidth: 200,
        },
        {
          prop: "companycode",
          label: "企业代码",
          textAlign: "center",
        },
        {
          prop: "scx",
          label: "生产线",
          textAlign: "center",
        },
        {
          prop: "jglx",
          label: "加工类型",
          minWidth: 100,
          handle: "jglx",
        },
        {
          prop: "datastate",
          label: "数据状态",
          handle: "datastate",
          textAlign: "center",
        },
        {
          prop: "upstate",
          label: "上报状态",
        },
        {
          prop: "lxsj",
          label: "是否离线",
          textAlign: "center",
        },
        {
          prop: "cjtime",
          label: "采集时间",
          minWidth: 100,
        },
        {
          prop: "uptime",
          label: "上传时间",
          minWidth: 100,
        },
        {
          prop: "sbtime",
          label: "上报时间",
          minWidth: 100,
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          textAlign: "left",
          minWidth: 100,
          fixed: "right",
        },
      ],
      tableData: [],
      componany: [],
      queryMsg: {},
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      addForm: {},
      drawerTitle: "",
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {};
      if (drawerTitle == "设备详情") {
        // queryDevice(data.sbid).then((res) => {
        //   this.addForm = res.data;
        //   this.changeOpen();
        // });
      } else {
        dataDetails({ id: data.id }).then((res) => {
          if (res.data.dates) res.data.dates = res.data.dates.substr(0, 10)
          this.addForm = res.data;
          this.changeOpen();
        });
      }
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getMinutePacket() {
      this.queryCount = 0;
      const company = (this.componany.find(
        (a) => a.companycode == this.queryParams.companycode
      ) || { companycode: null }).companycode;
      const minute = this.queryTime
      const productionLine = this.queryParams.sccode
      if (company && productionLine && minute) {
        const params = {
          minute,
          company,
          productionLine
        };
        if (this.queryParams.cjtime?.length) {
          params.cjTimeStart = this.queryParams.cjtime[0];
          params.cjTimeEnd = this.queryParams.cjtime[1];
        }
        if (this.queryParams.sctime?.length) {
          params.uploadTimeStart = this.queryParams.sctime[0];
          params.uploadTimeEnd = this.queryParams.sctime[1];
        }
        if (this.queryParams.sbtime?.length) {
          params.reportTimeStart = this.queryParams.sbtime[0];
          params.reportTimeEnd = this.queryParams.sbtime[1];
        }
        minutePacket(params).then((res) => {
          this.queryCount = res.data;
        });
      } else {
        this.queryCount = 0;
      }

    },
    getComponany() {
      queryCompany()
        .then((res) => {
          this.componany = res.data;
        })
        .catch((err) => {
          this.componany = [];
        });
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      if (this.queryParams.cjtime?.length) {
        params.cjTimeStart = this.queryParams.cjtime[0];
        params.cjTimeEnd = this.queryParams.cjtime[1];
      }
      if (this.queryParams.sctime?.length) {
        params.uploadTimeStart = this.queryParams.sctime[0];
        params.uploadTimeEnd = this.queryParams.sctime[1];
      }
      if (this.queryParams.sbtime?.length) {
        params.reportTimeStart = this.queryParams.sbtime[0];
        params.reportTimeEnd = this.queryParams.sbtime[1];
      }
      delete params.cjtime;
      delete params.sctime;
      delete params.sbtime;
      cjywStatistics(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.tableData.forEach((item) => {
            item.sbtime = item.sbtime ? moment(item.sbtime).format("YYYY-MM-DD HH:mm:ss") : '';
            item.cjtime = item.cjtime ? moment(item.cjtime).format("YYYY-MM-DD HH:mm:ss") : '';
            item.uptime = item.uptime ? moment(item.uptime).format("YYYY-MM-DD HH:mm:ss") : '';
          });
          this.queryMsg = res.data.cjywStatisticsTRes;
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.queryMsg = {};
          this.loading = false
        });
    },
  },
  created() {
    this.getComponany();
    this.getList();
  },
  watch: {
    "queryParams.cjtime"() {
      this.getMinutePacket();
    },
    "queryParams.sctime"() {
      this.getMinutePacket();
    },
    "queryParams.sbtime"() {
      this.getMinutePacket();
    },
    "queryParams.companycode"() {
      this.getMinutePacket();
    },
    "queryParams.sccode"() {
      this.getMinutePacket();
    },
    queryTime() {
      this.getMinutePacket();
    },
  },
};
</script>

<style scoped lang="scss">
.table_main .query {
  min-height: 120px;
}

.querymsg {
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 13px;

  .el-row {
    margin-top: 6px;
  }
}

.queryTime {
  >div {
    display: inline-block;
    margin-right: 10px;
  }
}

.red {
  color: $hong;
}
</style>
